export enum AccountRole {
    USER= "USER",
    PATIENT = "PATIENT",
    ADMIN = "ADMIN",
    MANAGER = "MANAGER"
  }